import { gql } from '@apollo/client';

export const UPDATE_BRAND = gql`
  mutation updateBrand($where: BrandWhereInput!, $data: BrandInput!) {
    updateBrand(where: $where, data: $data) {
      data {
        id
        name
        refData
        primaryColor
        logo {
          url
          key
          name
          extension
          contentType
        }
        secondaryColors
        tertiaryColors
        colorPallete
        description
        waiverText
        priceGuarantee
        offerText
        productDetails
        isActive
        tenantId
      }
      status
      message
    }
  }
`;

export const CREATE_BRAND = gql`
  mutation createBrand($data: BrandInput!) {
    createBrand(data: $data) {
      data {
        id
        name
        refData
        primaryColor
        logo {
          url
          key
          name
          extension
          contentType
        }
        secondaryColors
        tertiaryColors
        colorPallete
        description
        waiverText
        priceGuarantee
        offerText
        productDetails
        isActive
        tenantId
      }
      status
      message
    }
  }
`;

export const DELETE_BRAND = gql`
  mutation deleteBrand($where: BrandWhereInput!) {
    deleteBrand(where: $where) {
      message
      status
      data {
        id
      }
    }
  }
`;

export const CREATE_BRAND_LOB = gql`
  mutation createBrandLineOfBusiness(
    $data: [SelectLineOfBusiness!]!
    $where: BrandWhereInput!
  ) {
    createBrandLineOfBusiness(data: $data, where: $where) {
      message
      status
      data {
        id
      }
    }
  }
`;

export const UPDATE_BRAND_LOB = gql`
  mutation updateBrandLineOfBusiness(
    $data: [SelectLineOfBusiness!]!
    $where: BrandWhereInput!
  ) {
    updateBrandLineOfBusiness(data: $data, where: $where) {
      message
      status
      data {
        id
      }
    }
  }
`;
